import apiFetch from '@scale/frontend-lib/api-fetch';
import { MetricsObject, StatsCollector } from '@scale/shared/types/metrics';

const incrMetricsBin: MetricsObject[] = [];
const gaugeMetricsBin: MetricsObject[] = [];
const histogramMetricsBin: MetricsObject[] = [];
const distributionMetricsBin: MetricsObject[] = [];

let flushInterval: NodeJS.Timeout | null = null;

const flushMetricsToServer = async () => {
  if (
    incrMetricsBin.length ||
    gaugeMetricsBin.length ||
    histogramMetricsBin.length ||
    distributionMetricsBin.length
  ) {
    try {
      // empty out bins before in case request > 10s
      const metricsBins = {
        incrMetricsBin: [...incrMetricsBin],
        gaugeMetricsBin: [...gaugeMetricsBin],
        histogramMetricsBin: [...histogramMetricsBin],
        distributionMetricsBin: [...distributionMetricsBin],
      };
      incrMetricsBin.length = 0;
      gaugeMetricsBin.length = 0;
      histogramMetricsBin.length = 0;
      distributionMetricsBin.length = 0;
      await apiFetch(null, 'internal/frontendMetrics/flushMetrics', {
        method: 'POST',
        body: JSON.stringify(metricsBins),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      // eslint-disable-next-line no-empty
    } catch (error) {}
  }
};

class ScaleStatsCollector implements StatsCollector {
  constructor(public namespace: string) {}

  incr = (key: string, value: number, tags?: Record<string, string>): void => {
    incrMetricsBin.push({
      key: formatKey(this.namespace, key),
      value,
      tags,
    });
  };

  gauge = (key: string, value: number, tags?: Record<string, string>): void => {
    gaugeMetricsBin.push({
      key: formatKey(this.namespace, key),
      value,
      tags,
    });
  };

  histogram = (key: string, value: number, tags?: Record<string, string>): void => {
    histogramMetricsBin.push({
      key: formatKey(this.namespace, key),
      value,
      tags,
    });
  };

  distribution = (key: string, value: number, tags?: Record<string, string>): void => {
    distributionMetricsBin.push({
      key: formatKey(this.namespace, key),
      value,
      tags,
    });
  };
}

const formatKey = (namespace: string, key: string) => {
  if (namespace && namespace.length > 0) {
    return namespace + '.' + key;
  }
  return key;
};

const getStatsCollector = (namespace: string | string[]): StatsCollector => {
  if (!flushInterval) {
    flushInterval = setInterval(() => flushMetricsToServer(), 10000);
  }

  // a namespace can be an array of strings for more specific metric naming
  if (Array.isArray(namespace)) {
    const jointNamespace = namespace.join('.');
    return new ScaleStatsCollector(jointNamespace);
  }
  return new ScaleStatsCollector(namespace);
};

export default getStatsCollector;
